Hideaways.inputReplace = function() {
    $('select').not('.multi-select,.no-replace').selectreplace({
        wrapper     : 'div',
        wrapperClass: 'select-replace',
        value       : 'p',
        valueClass  : 'select-replace__value',
        svgIcon     : 'icon-chevron-down'
    });
    $('input[type="checkbox"]').checkReplace();
    $('input[type="radio"]').radioStyle();
}
